import React from 'react';
import { useSearchkit } from '@searchkit/client';
import Pagination from '../../Pagination';
var SearchPagination = function SearchPagination(_ref) {
  var data = _ref.data;
  var api = useSearchkit();
  if (!data) {
    return null;
  }
  var setCurrentPage = function setCurrentPage(page) {
    if (data && page) {
      api.setPage({
        size: data.results.hits.page.size,
        from: (page - 1) * data.results.hits.page.size
      });
      api.search();
    }
  };
  return /*#__PURE__*/React.createElement(Pagination, {
    setCurrentPage: setCurrentPage,
    totalPages: data.results.hits.page.totalPages,
    currentPage: data.results.hits.page.pageNumber + 1
  });
};
export default SearchPagination;